import { ICartItemV2 } from "@faire/web-api/faire/carts/ICartItemV2";
import React, { useContext } from "react";

import { BrandPageComposableTileQuickAddCallbackContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/BrandPageComposableTileQuickAddCallbackContext";
import { QuickAddProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import {
  IQuickAddEventParams,
  QuickAddTrackingEventsContextBaseProvider,
} from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/__internal__/QuickAddTrackingEventsProviders/QuickAddTrackingEventsContextBaseProvider";
import {
  useAddPendingCartItem,
  useClearPendingCartItems,
} from "@faire/retailer/views/brand/BrandCart/actions/useAddPendingCartItem";

export const BrandPageQuickAddTrackingEventsContextProvider = ({
  data,
  children,
}: {
  data: QuickAddProps;
  children: React.ReactNode;
}) => {
  const clearPendingCartItems = useClearPendingCartItems();

  const addPendingCartItem = useAddPendingCartItem();

  const { onChooseMultiOption } = useContext(
    BrandPageComposableTileQuickAddCallbackContext
  );

  const onQuickAddClick = ({ newQuantity }: IQuickAddEventParams) => {
    addPendingCartItem(
      ICartItemV2.build({
        name: data.productName,
        image: data.productImage,
        product_token: data.productToken,
        product_option_token: data.quickAdd?.quick_add_option?.option_token,
        quantity: newQuantity,
      })
    );
  };
  return (
    <QuickAddTrackingEventsContextBaseProvider
      data={data}
      onQuickAddSubmit={clearPendingCartItems}
      onQuickAddButtonClick={onQuickAddClick}
      onChooseOptionClick={onChooseMultiOption}
    >
      {children}
    </QuickAddTrackingEventsContextBaseProvider>
  );
};
